module.exports = __webpack_public_path__ + "media/images/project/arrow-down-thin-174f70efea75e9958c7bf3ca5d6a415d.svg";